import React from 'react';
import Icon from '../Icon'

export default function MaleIcon({ title }) {
    return (<Icon icon="businessman" title={title} style={{ color: "blue", fontSize: "16px", paddingRight: "4px" }} />);
};